import {BUSCAR_ULTIMOS_HISTORICOS_USUARIO, LIMPAR_ULTIMOS_HISTORICOS_USUARIO} from '../../actions/types'

const initialState = undefined

export default function reducerUltimosHistoricosUsuario(state = [], action = initialState) {
    switch (action.type) {
        case BUSCAR_ULTIMOS_HISTORICOS_USUARIO: {
            const historicos = action.payload.data;
            if (historicos) {
                return historicos;
            }
            return []
        }

        case LIMPAR_ULTIMOS_HISTORICOS_USUARIO:
            return [];

        default: {
            return state
        }
    }
}
